import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { MfaConfig } from 'lumen/models';
import type { Transition } from 'lumen/services/transition';

export default class MarketSettingsSecurityRoute extends Route {
  @service declare access: Services['access'];
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare firebaseService: Services['firebase-service'];
  @service declare store: Services['store'];
  @service declare transition: Services['transition'];

  mfaConfigsTask = task({ restartable: true }, async () => {
    let mfaConfig = null;

    try {
      mfaConfig = await this.store.query<MfaConfig>('mfa-config', {
        namespace: '',
        typeKey: 'sso/mfa-configs',
      });

      return [...mfaConfig];
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.alerting.showErrorAlert();
      this.errorTracking.captureException(error);
    }

    return null; // in this case something went wrong with the request
  });

  async beforeModel(transition: Transition): Promise<void> {
    try {
      await this.firebaseService.initialize();
    } catch (error) {
      this.errorTracking.captureException(error);
    }

    if (!this.access.canEditPersonalSettingsPassword) {
      this.transition.redirectToEnabledTab(transition);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const model = {
      mfaConfigsTask: this.mfaConfigsTask,
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    model.mfaConfigsTask.perform();

    return model;
  }

  @action refreshModel(): void {
    this.refresh();
  }
}
